<div class="wrapper wrapper-content mtv-property-company-page row hide-list-nav-tabs">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="isShowView"
         [ngStyle]="{width: isShowView ? 'calc(100% - 420px)' : '100%'}">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Management Company'"></filter>
                </div>
                <div class="col-sm-5">
                    <button (click)="createNew()"
                            type="button"
                            class="btn btn-w-m btn-primary pull-right">
                        <i class="fa fa-plus-circle"></i> New Management Company
                    </button>
                </div>
            </div>

            <tabs-wrapper>
                <tab-item [tabId]="'companies'">

            <div class="table-responsive"
                 [ngClass]="{'sk-loading': managementCompany.spinnerShow}"
                 [class.overflow-hidden]="managementCompany.emptyRowService.emptyRow.length > 0"
                 *ngIf="managementCompany.companiesTotal !== null">
                <table class="table table-striped table-hover footable" *ngIf="managementCompany.companies.length">
                    <thead>
                        <tr [ngClass]="{'noSort': managementCompany.companies.length < 2}">
                            <th></th>
                            <th (click)="managementCompany.urlService.orderBy('id', $event)"
                                class="footable-sorted">ID<span class="footable-sort-indicator"></span></th>
                            <th (click)="managementCompany.urlService.orderBy('name', $event)">Company Name<span
                                class="footable-sort-indicator"></span></th>
                            <th *ngIf="!isShowView">Primary Contact</th>
                            <th (click)="managementCompany.urlService.orderBy('address', $event)">Address<span
                                class="footable-sort-indicator"></span></th>
                            <th (click)="managementCompany.urlService.orderBy('phone', $event)">Phone #<span
                                class="footable-sort-indicator"></span></th>
                            <th (click)="managementCompany.urlService.orderBy('email', $event)">Email <span
                                class="footable-sort-indicator"></span></th>
                            <th *ngIf="!isShowView"># of Properties</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template ngFor let-item [ngForOf]="managementCompany.companies" let-index="index">
                            <tr [ngClass]="{'footable-odd': (index % 2 === 0)}"
                                (click)="toggleDetails(item)">
                                <td>
                                    <label class="img-checkbox">
                                        <input type="checkbox" [ngModel]="item.checked">
                                        <label><svg-checked></svg-checked></label>
                                    </label>
                                </td>
                                <td>{{item.id}}</td>
                                <td>{{item.name}}</td>
                                <td *ngIf="!isShowView">{{item.primaryContact}}</td>
                                <td>{{item.address}}</td>
                                <td>{{formatPhone(item.phone)}}</td>
                                <td>{{item.email}}</td>
                                <td *ngIf="!isShowView">{{item.numberOfProperties ? item.numberOfProperties : '-'}}</td>
                            </tr>
                        </ng-template>

                        <tr *ngFor="let item of managementCompany.emptyRowService.emptyRow"
                            style="cursor: default;">
                            <td></td>
                            <td>&nbsp;</td>
                            <td></td>
                            <td *ngIf="!isShowView"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td *ngIf="!isShowView"></td>
                        </tr>
                    </tbody>
                </table>
                <h2 *ngIf="managementCompany.companiesTotal === 0" class="text-center">Result Not Found</h2>
            </div>
                </tab-item>
            <pagination
                *ngIf="managementCompany.companiesTotal && managementCompany.urlService.queryParams['page'] && !managementCompany.spinnerShow"
                [total]="managementCompany.companiesTotal">
            </pagination>
            <spinner [spinnerShow]="managementCompany.spinnerShow"></spinner>

            </tabs-wrapper>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar" *ngIf="isShowView">
        <company-view
            [viewedItem]="viewedItem"
            (onAddOffice)="showAddOffice()"
            (onEditOffice)="showAddOffice($event)"
            (onRemoveOffice)="removeOffice($event)"
            (onRemove)="removeItem()"
            (onClose)="closeDetails()">
        </company-view>
    </div>
</div>

<company-modal *ngIf="isCreateNew" (onClose)="closeCreateNew()"></company-modal>
<office-modal *ngIf="isShowAddOffice"
              [data]="selectedOffice"
              [company-id]="viewedItem.id"
              (onUpdate)="updateOfficeView()"
              (onClose)="closeAddOffice()">
</office-modal>
<company-invitation-email-modal [company-id]="viewedItem.id"
                                [type]="managementCompany.invitationEmailModal"
                                *ngIf="managementCompany.invitationEmailModal">
</company-invitation-email-modal>



// WEBPACK FOOTER //
// /app/src/app/views/admin/management-company/management-company.component.html